import { css } from '@emotion/react';
import React from 'react';

import Heading from '@/src/shared/components/Heading';

const styles = {
  contactListsHeader: css`
    padding: 0.8rem 0 1.2rem 0;
  `,
};

function ContactListsItems({ contactLists }) {
  if (contactLists.length === 0) {
    return (
      <p>
        You are not on any contact lists. Please contact your account manager if you have any
        questions.
      </p>
    );
  }

  return (
    <>
      <Heading type={3} theme="default" size="md" weight="bold" css={styles.contactListsHeader}>
        Contact Lists ({contactLists.length})
      </Heading>
      {contactLists.map(list => {
        return <p key={list.CommitteeCode}>{list.CommitteeDescription}</p>;
      })}
    </>
  );
}

export default ContactListsItems;
